import './CustomPacingScheduleHeader.scss';

import { IconArrowLeft } from '@hulu-react-style-components/icons';
import { bem } from 'mission-control-common-components';
import React from 'react';

import Button from '../../../../../common/Button';
import { HEADER_BULK_CUSTOM_PACING_TITLE, HEADER_CANCEL_TEXT, HEADER_CONFIRM_TEXT } from '../constants';
import { useCustomPacingScheduleContext } from '../CustomPacingScheduleProvider/CustomPacingScheduleProvider';
import { Step } from '../types';

const [block, element] = bem('custom-pacing-schedule-header');

type Props = {
  confirmButtonDisabled?: boolean;
  onConfirm?: () => void;
  customConfirmText?: string;
  isLoading?: boolean;
  title?: string;
};

const CustomPacingScheduleHeader = ({
  confirmButtonDisabled = false,
  onConfirm,
  customConfirmText = HEADER_CONFIRM_TEXT,
  title = HEADER_BULK_CUSTOM_PACING_TITLE,
  isLoading,
}: Props): React.JSX.Element => {
  const { onClose, step, goToPrevStep } = useCustomPacingScheduleContext();

  const onClickSaveSchedule = (): void => {
    if (onConfirm) {
      onConfirm();
    }
  };

  const hasCancelButton = step !== Step.Result && step !== Step.ReportList;

  return (
    <div className={block()} data-testid="custom-pacing-schedule-header">
      {step !== Step.Initial && (
        <div className={element('arrow')}>
          <IconArrowLeft data-testid="back-icon" onClick={goToPrevStep} />
        </div>
      )}
      <div className={element('title')}>{title}</div>
      <div className={element('buttons-container')}>
        {hasCancelButton && (
          <Button size="medium" variant="outlined" className={element('close')} onClick={onClose}>
            {HEADER_CANCEL_TEXT}
          </Button>
        )}
        <Button
          disabled={confirmButtonDisabled}
          size="medium"
          className={element('next-step')}
          data-testid="next-button"
          onClick={onClickSaveSchedule}
          loading={isLoading}
        >
          {customConfirmText}
        </Button>
      </div>
    </div>
  );
};

export default CustomPacingScheduleHeader;
